import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { BackToTop } from './BackToTop';

type Props = StructuredContentDocument<{
  behavior: 'auto' | 'smooth';
}>;

export function BackToTopLink({ props }: Props) {
  return (
    <BackToTop
      sx={{
        color: 'blue.primary',
        paddingY: 1,
      }}
      arrowStyle="simple"
      scrollBehavior={props.behavior}
    />
  );
}
